export default "__VITE_PUBLIC_ASSET__98b1a92d__"